/* BRUSÉ — scroll-driven experience (vanilla) */
(function () {
  if (window.__bru) return;
  window.__bru = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var clamp = function (v, a, b) { return Math.max(a === undefined ? 0 : a, Math.min(b === undefined ? 1 : b, v)); };
  var smooth = function (t) { t = clamp(t); return t * t * (3 - 2 * t); };

  /* Split headlines into words */
  function initSplit(root) {
    root.querySelectorAll('.bru-split:not([data-split])').forEach(function (el) {
      el.setAttribute('data-split', '1');
      var i = 0;
      (function walk(node) {
        Array.prototype.slice.call(node.childNodes).forEach(function (n) {
          if (n.nodeType === 3) {
            var frag = document.createDocumentFragment();
            n.textContent.split(/(\s+)/).forEach(function (part) {
              if (!part) return;
              if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
              var w = document.createElement('span'); w.className = 'w';
              var s = document.createElement('span'); s.textContent = part; s.style.setProperty('--i', i++);
              w.appendChild(s); frag.appendChild(w);
            });
            n.parentNode.replaceChild(frag, n);
          } else if (n.nodeType === 1 && n.tagName !== 'BR') { walk(n); }
        });
      })(el);
    });
  }

  /* Reveals */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 }) : null;
  function initReveal(root) {
    root.querySelectorAll('.bru-reveal, .bru-split, .bru-mask').forEach(function (el) {
      if (!io || reduce) { el.classList.add('is-in'); return; }
      io.observe(el);
    });
  }

  /* Scenes */
  var scenes = [];
  function initScenes(root) {
    root.querySelectorAll('[data-scene]').forEach(function (el) {
      if (el.__s) return; el.__s = true;
      scenes.push(el);
    });
  }
  function progress(el) {
    var r = el.getBoundingClientRect();
    var total = r.height - window.innerHeight;
    return total > 0 ? clamp(-r.top / total) : 0;
  }
  function set(el, k, v) { el.style.setProperty(k, (Math.round(v * 1000) / 1000).toString()); }

  var handlers = {
    problem: function (el, p) {
      var lines = el.querySelectorAll('[data-line]');
      var n = lines.length;
      var s = p * (n + 0.8);
      var presence = [];
      lines.forEach(function (ln, i) {
        var local = s - i;
        var o = i === 0 ? clamp((1 - local) / 0.2) : clamp(Math.min(local / 0.2, (1 - local) / 0.2));
        if (i === n - 1) o = clamp(Math.min(local / 0.2, (1.15 - local) / 0.25));
        presence.push(clamp(Math.min((local + 0.35) / 0.35, (1.35 - local) / 0.35)));
        set(ln, '--o', o);
      });
      var bgs = el.querySelectorAll('[data-bg-from]');
      var owner = {}; bgs.forEach(function (bg) { owner[bg.getAttribute('data-bg-from')] = bg; });
      var cur = null, map = [];
      lines.forEach(function (ln, i) {
        if (owner[i]) cur = owner[i];
        else if (ln.getAttribute('data-continue') !== 'true') cur = null;
        map.push(cur);
      });
      bgs.forEach(function (bg) {
        var o = 0; map.forEach(function (b, i) { if (b === bg) o = Math.max(o, presence[i]); });
        set(bg, '--o', o);
      });
      var m = el.querySelector('[data-mask]');
      if (m) set(m, '--m', smooth((s - n + 0.05) / 0.6));
    },
    film: function (el, p) {
      var frames = el.querySelectorAll('[data-frame]');
      var caps = el.querySelectorAll('[data-cap]');
      var n = frames.length;
      var q = clamp((p - 0.04) / 0.9);
      var pos = q * (n - 1);
      frames.forEach(function (f, i) { set(f, '--o', clamp(1 - Math.abs(pos - i))); });
      caps.forEach(function (c, i) { set(c, '--o', clamp(1 - Math.abs(pos - i) * 2.2)); });
      var z = q < 0.78 ? 1 + 0.2 * smooth(q / 0.78) : 1.2 - 0.2 * smooth((q - 0.78) / 0.22);
      var wrap = el.querySelector('.bru-film__frames');
      if (wrap) set(wrap, '--z', reduce ? 1 : z);
    },
    tech: function (el, p) {
      var imgs = el.querySelectorAll('[data-timg]');
      var items = el.querySelectorAll('[data-titem]');
      var n = items.length;
      var pos = clamp((p - 0.04) / 0.92) * (n - 1);
      items.forEach(function (it, i) { set(it, '--o', clamp(1 - Math.max(0, Math.abs(pos - i) - 0.2) * 3)); });
      imgs.forEach(function (im, i) { set(im, '--o', clamp(1 - Math.max(0, Math.abs(pos - i) - 0.15) * 1.6)); });
      var c = el.querySelector('[data-tcount]');
      if (c) c.textContent = (Math.min(n, Math.round(pos) + 1)) + ' / ' + n;
    },
    trans: function (el, p) {
      set(el, '--w', smooth((p - 0.12) / 0.62));
    },
    hero: function (el) {
      set(el, '--hp', clamp(window.scrollY / window.innerHeight));
    }
  };

  function updateScenes() {
    scenes.forEach(function (el) {
      var r = el.getBoundingClientRect();
      var kind = el.getAttribute('data-scene');
      if (kind !== 'hero' && (r.bottom < -50 || r.top > window.innerHeight + 50)) return;
      var h = handlers[kind];
      if (h) h(el, progress(el));
    });
  }

  /* Buy module */
  var stickies = [];
  function initBuy(root) {
    root.querySelectorAll('[data-bru-buy]').forEach(function (el) {
      if (el.__buy) return; el.__buy = true;
      var form = el.querySelector('form');
      var qty = el.querySelector('[data-qty]');
      var priceEl = el.querySelector('[data-price]');
      var wasEl = el.querySelector('[data-was]');
      var perEl = el.querySelector('[data-per]');
      var hintEl = el.querySelector('[data-hint-out]');
      var sticky = document.getElementById(el.getAttribute('data-sticky'));
      var stickyPrice = sticky && sticky.querySelector('[data-sticky-price]');
      var opts = el.querySelectorAll('[data-q]');
      function choose(o) {
        opts.forEach(function (x) { x.classList.toggle('is-active', x === o); });
        o.querySelector('input').checked = true;
        qty.value = o.getAttribute('data-q');
        if (priceEl) priceEl.textContent = o.getAttribute('data-total');
        if (wasEl) wasEl.textContent = o.getAttribute('data-was') || '';
        if (perEl) perEl.textContent = o.getAttribute('data-per') || '';
        if (hintEl) hintEl.textContent = o.getAttribute('data-hint') || '';
        if (stickyPrice) stickyPrice.textContent = o.getAttribute('data-total');
      }
      opts.forEach(function (o) { o.addEventListener('click', function () { choose(o); }); });
      var a = el.querySelector('[data-q].is-active') || opts[0]; if (a) choose(a);

      if (form && el.getAttribute('data-direct') === 'true') {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var btn = form.querySelector('[type=submit]'); btn.disabled = true;
          var msg = el.querySelector('[data-msg]');
          var code = el.getAttribute('data-code');
          fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
            .then(function () {
              return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: [{ id: parseInt(form.querySelector('input[name=id]').value, 10), quantity: parseInt(qty.value, 10) || 1 }] }) });
            })
            .then(function (r) { if (!r.ok) throw new Error('add'); })
            // pausa breve: deja que los píxeles (Meta, etc.) envíen «añadir al carrito» antes de salir al pago
            .then(function () { return new Promise(function (ok) { setTimeout(ok, 800); }); })
            .then(function () { window.location.href = '/checkout' + (code ? '?discount=' + encodeURIComponent(code) : ''); })
            .catch(function () { btn.disabled = false; if (msg) msg.textContent = el.getAttribute('data-error') || 'Something went wrong. Please try again.'; });
        });
      }
      if (sticky) stickies.push({ s: sticky, buy: el });
    });
  }
  function updateSticky() {
    var vh = window.innerHeight;
    stickies.forEach(function (o) {
      var r = o.buy.getBoundingClientRect();
      var buyVisible = r.top < vh && r.bottom > 0;
      var past = window.scrollY > vh * 0.6;
      o.s.classList.toggle('is-on', past && !buyVisible);
    });
  }

  /* Drag-to-scroll strip (desktop) */
  function initStrip(root) {
    root.querySelectorAll('[data-strip]').forEach(function (t) {
      if (t.__st) return; t.__st = true;
      var down = false, x0 = 0, s0 = 0;
      t.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') return; down = true; x0 = e.clientX; s0 = t.scrollLeft; t.style.scrollSnapType = 'none'; });
      window.addEventListener('pointerup', function () { if (!down) return; down = false; t.style.scrollSnapType = ''; });
      t.addEventListener('pointermove', function (e) { if (down) t.scrollLeft = s0 - (e.clientX - x0); });
    });
  }


  /* Before / After slider */
  function initBA(root) {
    root.querySelectorAll('[data-ba]').forEach(function (f) {
      if (f.__ba) return; f.__ba = true;
      var knob = f.querySelector('.bru-ba__knob');
      var p = 50, down = false, touched = false;
      function set(v) { p = Math.max(0, Math.min(100, v)); f.style.setProperty('--p', p.toFixed(2)); if (knob) knob.setAttribute('aria-valuenow', Math.round(p)); }
      function fromX(x) { var r = f.getBoundingClientRect(); set((x - r.left) / r.width * 100); }
      f.addEventListener('pointerdown', function (e) { down = true; touched = true; f.setPointerCapture && f.setPointerCapture(e.pointerId); fromX(e.clientX); });
      f.addEventListener('pointermove', function (e) { if (down) fromX(e.clientX); });
      ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (t) { f.addEventListener(t, function () { down = false; }); });
      if (knob) knob.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { set(p - 5); e.preventDefault(); touched = true; }
        if (e.key === 'ArrowRight') { set(p + 5); e.preventDefault(); touched = true; }
      });
      /* Pequeña demostración al entrar en pantalla */
      if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var io = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return; io.disconnect();
        var keys = [[0, 50], [700, 72], [1500, 28], [2200, 50]], t0 = null;
        function step(ts) {
          if (touched) return;
          if (t0 === null) t0 = ts;
          var t = ts - t0, i = 1;
          while (i < keys.length - 1 && t > keys[i][0]) i++;
          var a = keys[i - 1], b = keys[i], k = Math.min(1, (t - a[0]) / (b[0] - a[0]));
          k = k < .5 ? 2 * k * k : 1 - Math.pow(-2 * k + 2, 2) / 2;
          set(a[1] + (b[1] - a[1]) * k);
          if (t < keys[keys.length - 1][0]) requestAnimationFrame(step);
        }
        setTimeout(function () { requestAnimationFrame(step); }, 400);
      }, { threshold: .55 });
      io.observe(f);
    });
  }


  /* Historia: deslizar en móvil, secuencia con el scroll en ordenador */
  var stories = [];
  function initStory(root) {
    root.querySelectorAll('[data-story]').forEach(function (st) {
      if (st.__s) return; st.__s = true;
      var track = st.querySelector('.bru-story__track');
      var slides = [].slice.call(st.querySelectorAll('.bru-story__slide'));
      var bars = [].slice.call(st.querySelectorAll('.bru-story__bars i'));
      var n = slides.length, cur = 0, mq = window.matchMedia('(min-width: 990px)');
      function head() { return parseFloat(getComputedStyle(st).getPropertyValue('--head')) || 0; }
      function cl(v, a, b) { return Math.max(a, Math.min(b, v)); }
      function setActive(i) { i = cl(i, 0, n - 1); if (i === cur && slides[i].classList.contains('is-active')) return; slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); }); cur = i; }
      function fill(f) { bars.forEach(function (b, k) { b.style.setProperty('--f', cl(f - k, 0, 1).toFixed(3)); }); }
      function go(i) {
        i = cl(i, 0, n - 1);
        if (mq.matches) {
          var top = st.getBoundingClientRect().top + window.pageYOffset - head(), span = st.offsetHeight - (window.innerHeight - head());
          window.scrollTo({ top: top + span * (i / Math.max(1, n - 1)) + 2, behavior: 'smooth' });
        } else track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      }
      track.addEventListener('scroll', function () {
        if (mq.matches) return;
        var x = track.scrollLeft / Math.max(1, track.clientWidth);
        slides.forEach(function (s, k) { s.style.setProperty('--off', (k - x).toFixed(3)); });
        setActive(Math.round(x)); fill(x + 1);
        if (x > .15) st.classList.add('is-swiped');
      }, { passive: true });
      track.addEventListener('click', function (e) {
        if (mq.matches || e.target.closest('a, button')) return;
        var r = track.getBoundingClientRect();
        go(cur + ((e.clientX - r.left) > r.width * .3 ? 1 : -1));
      });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { go(cur + 1); e.preventDefault(); }
        if (e.key === 'ArrowLeft') { go(cur - 1); e.preventDefault(); }
      });
      st.querySelectorAll('.bru-story__arrow').forEach(function (b) { b.addEventListener('click', function () { go(cur + parseInt(b.getAttribute('data-dir'), 10)); }); });
      st.__update = function () {
        if (!mq.matches) return;
        var r = st.getBoundingClientRect(), span = Math.max(1, st.offsetHeight - (window.innerHeight - head()));
        var p = cl((head() - r.top) / span, 0, 1) * (n - 1);
        setActive(Math.floor(p + .5)); fill(p + 1);
      };
      fill(1);
      stories.push(st);
    });
  }
  function updateStories() { stories.forEach(function (s) { s.__update && s.__update(); }); }

  var ticking = false;
  function tick() { updateScenes(); updateSticky(); updateStories(); ticking = false; }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(tick); } }

  function initAll(root) {
    root = root || document;
    initSplit(root); initReveal(root); initScenes(root); initBuy(root); initStrip(root); initBA(root); initStory(root);
    tick();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  window.addEventListener('load', onScroll);
  window.addEventListener('pageshow', onScroll);
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
